
import Vue, { PropType } from 'vue';
import CustomFieldLabel from '@/components/_CustomFields/CustomFieldLabel.vue';
import CustomFieldValue from '@/components/_CustomFields/CustomFieldValue.vue';
import { Custom_Field_Definition } from '@/schema/custom_fields';

export default Vue.extend({
	components: {
		CustomFieldLabel,
		CustomFieldValue
	},
	props: {
		customFieldDefinitions: { type: Array as PropType<Custom_Field_Definition[]>, required: true },
		customFields: { type: Object, required: false, default: () => ({}) }
	}
});
